
import axios from 'axios';

class StaffService {
  get() {
    return axios.get(`${process.env.REACT_APP_API_URL}/staff`)
  }

  photo(id) {
    return `${process.env.REACT_APP_API_URL}/staff/photo/${id}`;
  }
}

export default new StaffService();
